// extracted by mini-css-extract-plugin
export default {"defaultLink":"_AZrl6zKHpV2U7wNpDwW"};